/**
 * Marketplace category taxonomy.
 *
 * Defines the top-level Category and Sex unions plus per-category item type
 * unions (fashion, art, furniture, jewelry) with matching runtime arrays, and
 * FullCategories, which maps each category to its available types (split by
 * sex where relevant). Used by bounty types/pages, search pages, and the
 * bounty API modules for category pickers and validation.
 */
export type Category = "fashion" | "watches" | "jewelry" | "art" | "furniture";

export type Sex = "male" | "female";

export const Categories: readonly Category[] = [
    "fashion",
    "watches",
    "jewelry",
    "furniture",
    "art",
];

export const Sexes: readonly Sex[] = ["male", "female"];

export type SharedFashionType =
    | "pants"
    | "jeans"
    | "shoes"
    | "sweater"
    | "coat"
    | "scarf"
    | "bag"
    | "hat"
    | "belt";

export type MaleFashionType = SharedFashionType | "shirt" | "tshirt";

export type FemaleFashionType = SharedFashionType | "dress" | "skirt" | "top";

export const SharedFashionTypes: readonly SharedFashionType[] = [
    "pants",
    "jeans",
    "shoes",
    "sweater",
    "coat",
    "scarf",
    "bag",
    "hat",
    "belt",
];

export const MaleFashionTypes: readonly MaleFashionType[] = [
    ...SharedFashionTypes,
    "shirt",
    "tshirt",
];

export const FemaleFashionTypes: readonly FemaleFashionType[] = [
    ...SharedFashionTypes,
    "dress",
    "skirt",
    "top",
];

export type ArtType = "painting" | "sculpture" | "photography" | "print" | "drawing";

export const ArtTypes: readonly ArtType[] = [
    "painting",
    "sculpture",
    "photography",
    "print",
    "drawing",
];

export type FurnitureType =
    | "chair"
    | "table"
    | "sofa"
    | "bed"
    | "desk"
    | "shelf"
    | "dresser"
    | "armoire";

export const FurnitureTypes: readonly FurnitureType[] = [
    "chair",
    "table",
    "sofa",
    "bed",
    "desk",
    "shelf",
    "dresser",
    "armoire",
];

export type JewelryType = "necklace" | "bracelet" | "ring" | "earrings";

export const JewelryTypes: readonly JewelryType[] = ["necklace", "bracelet", "ring", "earrings"];

export const FullCategories = {
    fashion: {
        male: MaleFashionTypes,
        female: FemaleFashionTypes,
    },
    watches: Sexes,
    jewelry: {
        male: JewelryTypes,
        female: JewelryTypes,
    },
    art: ArtTypes,
    furniture: FurnitureTypes,
};
